<template>
    <transition name="slide-fade">
        <s-form-group :id="id" v-if="schema.config[fieldName].show">

            <s-form-checkbox-group
                    :id="fieldName+'group-1'"
                    :name="fieldName"
                    :aria-required="schema.config[fieldName].validation.required"
                    :options="$t('message.fields.'+fieldName+'.options')"
                    v-model="schema.fields[fieldName]"
                    stacked
            ></s-form-checkbox-group>
        </s-form-group>
    </transition>
</template>

<script>

    import formHelpers from '../../utils/helpers/formHelpers'
    import sFormCheckboxGroup from '../form/s-form-checkbox-group'
    import sFormGroup from '../form/s-form-group'

    export default {
        name: 'sCheckboxListGroup',
        mixins: [formHelpers],
        props: {
            fieldName: String
        },
        data() {
            return {
                schema: this.$root.$data.schema,
                id: 'py-formGroup-' + this.fieldName
            }
        },
        inject: {
            $validator: '$validator'
        },
        components: {
            sFormCheckboxGroup,
            sFormGroup
        },
        mounted() {
            this.addEventListeners()
        }
    }

</script>

<style>
    .custom-controls-stacked > .custom-checkbox{
        padding-bottom: 10px;
    }
    .custom-controls-stacked > .custom-checkbox:last-child {
        padding-bottom: 0;
    }
</style>